import { create } from "zustand";
import axios from "axios";
import authStore from "./authStore";
import { ENV, KEY_ID } from "../constant";
import paymentStore from "./paymentStore";
import orderStore from "./orderStore";
import cartStore from "./cartStore";
import couponStore from "./couponStore";
import orderDeliveryStatusTimeStore from "./orderDeliveryStatusTimeStore";
import productStore from "./productStore";
import Cookies from "js-cookie";

const paymentGetWayStore = create((set) => ({
  onlinePayment: async ({ totalAmount }) => {
    try {
      const data = await axios.post("/site/create-razorpay-order", {
        totalAmount: ENV === "production" ? parseInt(totalAmount) : parseInt(1),
      });
      if (data) {
        return data.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  },

  initPayment: ({ data }) => {
    const { myUser } = authStore.getState();
    const options = {
      key: KEY_ID,
      amount: data.amount,
      currency: data.currency,
      order_id: data.id,
      name: "KRISTIVE",
      description: "Credits towards consultation",
      // image: "https://i.imgur.com/3g7nmJC.png",
      handler: async (response) => {
        const { setIsPaymentLoading } = paymentStore.getState();
        setIsPaymentLoading({ value: true });
        try {
          const verify = await axios.post(
            "/site/verify-razorpay-payment",
            response,
          );
          if (verify) {
            const { createPayment, setIsPaymentLoading } =
              paymentStore.getState();

            const paymentID = await createPayment({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              paymentType: "online",
            });
            const { createOrder, setIsOrderSuccessfully } =
              orderStore.getState();
            const { createOrderDeliveryStatusTime } =
              orderDeliveryStatusTimeStore.getState();

            const orderDeliveryStatusTimeID =
              await createOrderDeliveryStatusTime();

            const { cartProduct, whenOrderCartEmpty, couponAmount } =
              cartStore.getState();
            const { mProduct } = productStore.getState();
            for (let i = 0; i < cartProduct.length; i++) {
              let purchasePrice = 0;
              for (let j = 0; j < mProduct.length; j++) {
                if (cartProduct[i].productID === mProduct[j]._id) {
                  if (mProduct[j].salePrice) {
                    purchasePrice = mProduct[j].salePrice;
                  } else {
                    purchasePrice = mProduct[j].regularPrice;
                  }
                  break;
                }
              }
              await createOrder({
                productID: cartProduct[i].productID,
                selectedSize: cartProduct[i].selectedSize,
                selectedColor: cartProduct[i].selectedColor,
                quantity: cartProduct[i].qty,
                purchasePrice,
                paymentID,
                orderDeliveryStatusTimeID,
              });
            }
            const { copyCouponCode, usedCoupon } = couponStore.getState();
            if (couponAmount !== 0) {
              await usedCoupon({ _id: copyCouponCode._id });
            }

            await whenOrderCartEmpty();
            setIsPaymentLoading({ value: false });
            setIsOrderSuccessfully({ value: true });
            return true;
          } else {
            setIsPaymentLoading({ value: false });
            return false;
          }
        } catch (error) {
          console.log(error);
          setIsPaymentLoading({ value: false });
        }
      },
      prefill: {
        name: `${myUser.firstName} ${myUser.lastName}`,
        email: myUser.email,
        contact: myUser.phoneNumber,
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  },
}));

export default paymentGetWayStore;
